import CustomerServices from '../../services/CustomerServices'
import CodeList from '../../code/CodeList'
import ContractServices from "@/services/ContractServices";
import NoticeServices from "@/services/NoticeServices";

const types = {
  GET_COMPANY_LIST: '@customer/GET_COMPANY_LIST',
  GET_CUSTOMERS_GROUP_LIST: '@customer/GET_CUSTOMERS_GROUP_LIST',
  GET_CUSTOMERS_LIST: '@customer/GET_CUSTOMERS_LIST',
  GET_CUSTOMERS_CONTRACT: '@customer/GET_CUSTOMERS_CONTRACT',
  GET_CUSTOMERS_CONTRACT_LIST_PREV: '@customer/GET_CUSTOMERS_CONTRACT_LIST_PREV',
  GET_CUSTOMERS_CONTRACT_LIST: '@customer/GET_CUSTOMERS_CONTRACT_LIST',
}

export {
  types as customerTypes
}

export default {
  namespaced: true,
  state: {
    codeCustomerList: CodeList.READY,
    codeCompanyList: CodeList.READY,
    companyList: [],
    groupList: [],
    customerList: [],
    customerListContract: [],
    customerContractListPrev: [],
    customerContractList: [],
  },

  getters: {
    codeCompanyList: state => state.codeCompanyList,
    companyList: state => state.companyList,
    codeCustomerList: state => state.codeCustomerList,
    groupList: state => state.groupList,
    groupInfoById: state => (id) => state.groupList.find(item => item.id === id) || {},
    customerList: state => state.customerList,
    customerListContract: state => state.customerListContract,
    customerContractList: state => state.customerContractList,
    customerContractListPrev: state => state.customerContractListPrev,

  },

  mutations: {
    [types.GET_COMPANY_LIST] (state, payload) {
      state.codeCompanyList = payload.codeCompanyList
      state.companyList = payload.companyList
    },
    [types.GET_CUSTOMERS_GROUP_LIST] (state, payload) {
      state.groupList = payload.groupList
    },
    [types.GET_CUSTOMERS_LIST] (state, payload) {
      state.codeCustomerList = payload.codeCustomerList
      state.customerList = payload.customerList
    },
    [types.GET_CUSTOMERS_CONTRACT] (state, payload) {
      state.customerListContract = payload.customerListContract

    },
    [types.GET_CUSTOMERS_CONTRACT_LIST_PREV] (state, payload) {
      state.customerContractListPrev = payload.customerContractListPrev

    },
    [types.GET_CUSTOMERS_CONTRACT_LIST] (state, payload) {
      state.customerContractList = payload.customerContractList

    },

  },

  actions: {
    async getCustomersGroups({commit}) {
      const response = await CustomerServices.getCustomersGroups()
      commit(types.GET_CUSTOMERS_GROUP_LIST, {
        groupList: response.data.resultData
      })
      return null
    },
    async getCustomerList({commit}) {
      
      commit(types.GET_CUSTOMERS_LIST, {
        codeCustomerList: CodeList.READY,
        customerList: []
      })
      try {
        const response = await CustomerServices.getCustomerUsers()

        commit(types.GET_CUSTOMERS_LIST, {
          codeCustomerList: CodeList.SUCCESS,
          customerList: response.data.resultData
        })
      } catch (e) {
        commit(types.GET_CUSTOMERS_LIST, {
          codeCustomerList: CodeList.EXCEPTION,
          customerList: []
        })
      }
      return null
    },
    async getCompanyList ({commit}) {
      commit(types.GET_COMPANY_LIST, {
        codeCompanyList: CodeList.READY,
        companyList: []
      })
      try {
        const response = await CustomerServices.getCustomersCompanys()
        commit(types.GET_COMPANY_LIST, {
          codeCompanyList: CodeList.SUCCESS,
          companyList: response.data.resultData
        })
      } catch (e) {
        commit(types.GET_COMPANY_LIST, {
          codeCompanyList: CodeList.EXCEPTION,
          companyList: []
        })
      }
      return null
    },
    async getCustomersCompanysList ({commit}) {
      commit(types.GET_COMPANY_LIST, {
        codeCompanyList: CodeList.READY,
        companyList: []
      })
      try {
        const response = await CustomerServices.getCustomersCompanysList()
        commit(types.GET_COMPANY_LIST, {
          codeCompanyList: CodeList.SUCCESS,
          companyList: response.data.resultData
        })
      } catch (e) {
        commit(types.GET_COMPANY_LIST, {
          codeCompanyList: CodeList.EXCEPTION,
          companyList: []
        })
      }
      return null
    },
    async getCustomersContract ({commit},payload) {

      const { customerCode, customerDeptCode,companyCode } = payload

      const response = await CustomerServices.getCustomersContract({
        customerCode, customerDeptCode,companyCode
      })

      commit(types.GET_CUSTOMERS_CONTRACT, { customerListContract: response.data.resultData});

      return response.data.resultData;
    },

    async insertCustomerContract ({ commit }, payload) {
      const {contractCode, customerCode, customerDeptCode, companyCode} = payload
      const response = await CustomerServices.insertCustomerContract(
        {contractCode, customerCode, customerDeptCode, companyCode}
      )
      return response.data.resultData
    },



    async getCustomerContractPrev ({commit},payload) {

      const { customerCode, customerDeptCode,companyCode } = payload

      const response = await CustomerServices.getCustomerContractPrev({
        customerCode, customerDeptCode,companyCode
      })

      commit(types.GET_CUSTOMERS_CONTRACT_LIST_PREV, { customerContractListPrev: response.data.resultData});

      return response.data.resultData;
    },

    async deleteCustomerContractPrev ({ commit },  payload) {
      const { customerCode, customerDeptCode,companyCode,contractCode } = payload
      const response = await CustomerServices.deleteCustomerContractPrev(customerCode, customerDeptCode,companyCode,contractCode)
      return response.data.resultData
    },

    async getCustomerContractList ({commit},payload) {

      const { customerCode, customerDeptCode,companyCode,userEmail } = payload

      const response = await CustomerServices.getCustomerContract({
        customerCode, customerDeptCode,companyCode,userEmail
      })

      commit(types.GET_CUSTOMERS_CONTRACT_LIST, { customerContractList: response.data.resultData});

      return response.data.resultData;
    },
    async insertCustomerContractList ({ commit }, payload) {
      const {popupStr, customerCode, customerDeptCode, companyCode,userEmail} = payload
      const response = await CustomerServices.insertCustomerContractList(
        {popupStr, customerCode, customerDeptCode, companyCode,userEmail}
      )
      return response.data.resultData
    },


    async getCustomersAllList ({ commit }, payload) {
      const response = await CustomerServices.getCustomersAllList()
      return response.data.resultData
    },

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/customer.js